import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { comment } from '../../../constants/payData';
import { selectorsLocale } from '../../../redux/locale/localeReducer';
import { buildLocale } from '../../../utils/buildLocale';
import { setLocaleStorageItem, getLocaleStorageItem } from '../../../utils/localStorageHelper';

interface IProps {
  debCreateDraft: () => void;
}

const CommentDataComponent = (props: IProps) => {
  const { debCreateDraft } = props;
  const currentTranslate = useSelector(selectorsLocale.getTranslate);
  const [commentValue, setCommentValue] = useState('');
  const [isEditMode, setIsEditMode] = useState(false);

  useEffect(() => {
    const localeComment = getLocaleStorageItem(comment);
    setCommentValue(localeComment || '');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (commentValue?.length && !isEditMode) {
      setIsEditMode(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [commentValue]);

  const changeComment = (value: string) => {
    setCommentValue(value);
    setLocaleStorageItem(comment, value);
  };

  const onChangeEditMode = () => {
    setIsEditMode(!isEditMode);
  };

  return (
    <div>
      <div className="pay-block_title">
        <div className="title">
          <span className="number">4</span> {buildLocale(currentTranslate, 'cartComment')}
        </div>
        <button
          onClick={() => onChangeEditMode()}
          className={`checkout-edit-button${isEditMode ? '_inactive' : '_active'}`}
          aria-label="Bearbeiten">
          <i className="fa fa-pencil"></i>
        </button>
      </div>
      {isEditMode && (
        <div className="row">
          <div className="col-12">
            <div className="form-item">
              <label>{buildLocale(currentTranslate, 'cartComment')}</label>
              <textarea
                className="form-control"
                value={commentValue}
                onChange={(e) => {
                  changeComment(e.target.value);
                }}
                onBlur={debCreateDraft}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CommentDataComponent;
